"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHighlightElementStyles = void 0;
var getHighlightElementStyles = function (color) { return ({
    boxShadow: "0 0 0 2px ".concat(color || '#777777')
}); };
exports.getHighlightElementStyles = getHighlightElementStyles;
//# sourceMappingURL=editor.js.map